// Scope: renders one active or archived MERN note and its available action.

import React from "react";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import OpenInNewTwoToneIcon from "@mui/icons-material/OpenInNewTwoTone";

function Note(props) {
    const { title, content, timeCreated, status, archiveNote, restoreNote, displayNote } =
        props;

    // Truncating the displayed Data

    const titleLimit = 30;
    const contentLimit = 200;

    const limitedTitle =
        title.length > titleLimit
            ? title.substring(0, titleLimit) + "..."
            : title;
    const limitedContent =
        content.length > contentLimit
            ? content.substring(0, contentLimit) + "..."
            : content;

    // Showing Formatted time

    const date = new Date(timeCreated);

    const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Edmonton",
    };

    const formattedDate = new Intl.DateTimeFormat("en-CA", options).format(
        date
    );

    return (
        <div className="note">
            <h1>{limitedTitle}</h1>
            <button className="note-read" onClick={displayNote} aria-label={`Open ${title}`}>
                <OpenInNewTwoToneIcon />
            </button>
            <p className="note-content">{limitedContent}</p>

            <p className="note-status">status: {status}</p>

            <div className="note-bottom">
                <p className="time-stamp">
                    <span role="img" aria-label="clock emoji">
                        🕔
                    </span>{" "}
                    {formattedDate}
                </p>

                <button
                    className="note-delete"
                    onClick={status === "deleted" ? restoreNote : archiveNote}
                    aria-label={status === "deleted" ? `Restore ${title}` : `Archive ${title}`}
                    title={status === "deleted" ? "Restore note" : "Archive note"}
                >
                    {status === "deleted" ? <RestoreOutlinedIcon /> : <ArchiveOutlinedIcon />}
                </button>
            </div>
        </div>
    );
}

export default Note;
